import { Modal, List, Tooltip } from "antd";
import { useLoading } from "context/loadingContext";
import getFAQ from "functions/ai/getFAQ";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const FAQModal = ({ open, onClose }) => {
  const { showLoading, hideLoading } = useLoading();
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    if (open) fetchFaq();
  }, [open]);

  const fetchFaq = async () => {
    showLoading();
    try {
      const response = await getFAQ();
      setFaqs(response.data || []);
    } catch (error) {
      console.error("Error fetching FAQ:", error);
    } finally {
      hideLoading();
    }
  };

  return (
    <Modal
      open={open}
      title="Хэрэглэгчийн асуултууд"
      onCancel={onClose}
      footer={null}
      className="faq-modal"
    >
      <List
        dataSource={faqs}
        locale={{ emptyText: "Асуулт байхгүй байна" }}
        renderItem={(item) => (
          <List.Item className="flex flex-col items-start">
            <div className="w-full mb-1">
              <div className="font-medium text-gray-800">{item.question}</div>
              <div className="flex justify-between items-center mt-1 text-xs text-gray-400">
                <span>{dayjs(item.createdAt).format("YYYY-MM-DD HH:mm")}</span>
                {item.aiFunctionCall ? (
                  <Tooltip title={item.aiFunctionCall.answer}>
                    <span className="text-green-600 truncate max-w-[220px] block">
                      {String(item.aiFunctionCall.answer).substring(0, 60)}...
                    </span>
                  </Tooltip>
                ) : (
                  <span className="text-red-500">Хариулж чадаагүй</span>
                )}
              </div>
            </div>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default FAQModal;
